export default "/images/claritask2000 px.svg?bca6932615102821f42f766ff1ba4a0d";